/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Viewer } from '../models/Viewer';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ViewerService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Viewer
   * Return information about the authenticated user
   * @returns Viewer OK
   * @throws ApiError
   */
  public viewer(): CancelablePromise<Viewer> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/viewer',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

}
